module.exports = __webpack_public_path__ + "img/ype100s2_4z.prt.ff916182.jpg";